import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Formatters } from 'angular-slickgrid';
import { CustomInputEditor } from '../custom-inputEditor';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ticket-config',
  templateUrl: './ticket-config.component.html',
  styleUrls: ['./ticket-config.component.css']
})
export class TicketConfigComponent implements OnInit, OnDestroy {

  displayed = true;
  prefix: string;
  dropdown: string;
  clientId: number;

  add = false;
  del = false;
  edit = false;
  view = false;

  displayData: any;

  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;
  types = [];
  private notifier: NotifierService;
  typeSelected1: number;
  typeSelected2: number;
  typeSelected3: number;
  typeChecked: number;
  type: string;
  ttypes = [];
  length: any;
  private startValue = 'D';
  categories = [];
  categorySelected: number;
  private categoriyName: string;
  catPrefix: string;
  prefix1: string;
  prefix2: string;
  prefix3: string;
  prefixType: any;
  isReadonly1 = false;
  isReadonly2 = false;
  isReadonly3 = false;
  prefixLength = 3;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  isIncrimental: boolean;
  startNumber: number;
  dataLoaded: boolean;
  ticketType: string;
  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            // if (confirm('Are you sure?')) {
            //   item.user_id = this.messageService.getUserId();
            //   this._rest.updateBusinessPriority(item).subscribe((res) => {
            //     this.respObject = res;
            //     if (this.respObject.success) {
            //       // console.log('data--Done');
            //       this.notifier.notify('success', 'Updated successfully');
            //     } else {
            //       // console.log('data--Not---Done');
            //       this.notifier.notify('error', this.respObject.errorMessage);
            //     }
            //   }, (err) => {
            //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
            //   });
            // }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
              // this._rest.deleteTicketExtandMstTbl({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
              //   this.respObject = res;
              //   if (this.respObject.success) {
              //     this.totalData = this.totalData - 1;
              //     this.messageService.setTotalData(this.totalData);
              //     this.messageService.sendAfterDelete(item.id);
              //   } else {
              //     this.notifier.notify('error', this.respObject.errorMessage);
              //   }
              // }, (err) => {
              //   this.notifier.notify('error', this.messageService.SERVER_ERROR);
              // });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });

  }


  ngOnInit() {
    this.dataLoaded = false;
    this.isIncrimental = false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.startNumber = 0;
    this.displayData = {
      pageName: 'Maintain Ticket Configuration',
      openModalButton: 'Add Ticket Configuration',
      breadcrumb: 'TicketConfiguration',
      folderName: 'All Ticket Configuration',
      tabName: 'TicketConfiguration'
    };
    this.prefixType = [{ id: 0, name: 'Select Prefix' }, { id: 1, name: 'Prefix' }, { id: 2, name: 'Category Prefix' }, {
      id: 3,
      name: 'Date Format'
    }];

    this.typeSelected1 = 0;
    this.typeSelected2 = 0;
    this.typeSelected3 = 0;

    const columnDefinitions = [
      // {
      //   id: 'delete',
      //   field: 'id',
      //   excludeFromHeaderMenu: true,
      //   formatter: Formatters.deleteIcon,
      //   minWidth: 30,
      //   maxWidth: 30,
      // },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'prefix1', name: 'Prefix1', field: 'prefix1', sortable: true, filterable: true, cssClass: 'highlight'
      },
      {
        id: 'prefix2', name: 'Prefix2', field: 'prefix2', sortable: true, filterable: true
      },
      {
        id: 'prefix3', name: 'Prefix3', field: 'prefix3', sortable: true, filterable: true
      },
      {
        id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
      },
      {
        id: 'start_number', name: 'Start Number', field: 'start_number', sortable: true, filterable: true
      },
      {
        id: 'ttype', name: 'Ticket Type', field: 'ttype', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          // console.log(JSON.stringify(this.respObject));
          if (this.respObject.success) {
            this.typeChecked = this.respObject.details[0].id;
            this.type = this.respObject.details[0].name;
            this.ttypes = this.respObject.details;
            this.getCategory();
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.prefix1 = '';
      this.prefix3 = '';
      this.prefix2 = '';
      this.categorySelected = 0;
      this.modalService.open(content, { size: 'sm' }).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  save() {
    let is_running_serial_no;
    if (this.isIncrimental === true) {
      is_running_serial_no = 'Y';
    } else {
      is_running_serial_no = 'N';
    }
    const data = {
      clientId: this.clientId,
      ticketType: this.typeChecked,
      category_id: this.categorySelected,
      // startWith: this.startValue,
      is_running_serial_no: is_running_serial_no,
      createdBy: this.messageService.getUserId()
    };
    // console.log(typeof this.typeSelected, this.typeSelected);
    if (!this.messageService.isBlankField(data)) {
      data['yrCntNo'] = this.startNumber;
      data['prefix1'] = this.prefix1;
      data['prefix2'] = this.prefix2;
      data['prefix3'] = this.prefix3;
      this._rest.insertTicketIdConfigure(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          // console.log(this.respObject)
          const id = this.respObject.details;
          this.messageService.setRow({
            id: id,
            prefix1: this.prefix1,
            ttype: this.typeChecked,
            category: this.categoriyName,
            prefix2: this.prefix2,
            prefix3: this.prefix3,
            start_number: this.startNumber
          });
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);

          if (this.totalData <= this.pageSize * this.page_no) {
            this.offset = id;
            this.nextOffset = 0;
          } else {
            this.nextOffset = this.offset;
          }
          this.prefix1 = '';
          this.prefix3 = '';
          this.prefix2 = '';
          this.typeSelected1 = 0;
          this.typeSelected2 = 0;
          this.typeSelected3 = 0;
          this.isReadonly1 = false;
          this.isReadonly2 = false;
          this.isReadonly3 = false;
          this.categorySelected = 0;
          this.isIncrimental = false;
          this.startNumber = 0;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_FIELD;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    this._rest.getTicketIdConfigure(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  executeResponse(respObject, offset, paginationType) {
    if (respObject.success) {
      this.dataLoaded = true;
      if (offset === 0) {
        this.totalData = respObject.details.totalData[0].count;
        this.totalPage = respObject.details.totalPage;
        if (this.totalPage === 0) {
          this.totalPage = 1;
        }
      }
      if (!this.isEmpty(respObject.details.dataObj)) {
        const data = respObject.details.dataObj;
        this.nextOffset = respObject.details.nextOffset;
        this.previousOffset = respObject.details.previousOffset;
        this.messageService.setTotalData(this.totalData);
        this.messageService.setGridData(data);
        // ----------------------------------------------
        if (offset !== 0) {
          const totalCount = this.totalData;
          const divRes = totalCount / this.pageSize;
          const remainder = totalCount % this.pageSize;
          if (remainder === 0) {
            this.totalPage = parseInt(String(divRes), 10);
          } else {
            this.totalPage = parseInt(String(divRes), 10) + 1;
          }
        }
        // ------------------------------------------------
        if (paginationType === 'next') {
          this.page_no = this.page_no + 1;
        } else if (paginationType === 'prev') {
          this.page_no = this.page_no - 1;
        } else if (paginationType === '' && this.page_no === 0) {
          this.page_no = this.page_no + 1;
        }
        if (this.totalData <= this.pageSize * this.page_no) {
          this.nextOffset = 0;
        }
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
        this.nextOffset = 0;
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
        this.previousOffset = 0;
      } else if (paginationType === '' && this.page_no === 0) {
        this.page_no = this.page_no + 1;
      }
    } else {
      this.notifier.notify('error', respObject.errorMessage);
    }
  }

  onButtonChange(value) {
    this.typeChecked = value.value;
    this.getCategory();
  }

  getCategory() {
    this._rest.getFirstLevelCategoryByTicket(this.clientId, this.typeChecked).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        // console.log(this.respObject);
        this.respObject.details.unshift({ id: 0, name: 'Select Category' });
        this.categories = this.respObject.details;
        this.categorySelected = 0;
      } else {
        this.categories = [];
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onCategoryChange(selectedIndex) {
    this.categoriyName = this.categories[selectedIndex].name;
  }

  onStartButtonChange(value) {
    this.startValue = value.value;
  }

  onType1Change() {
    console.log(typeof this.typeSelected1, this.typeSelected1);
    if (Number(this.typeSelected1) === 3) {
      this.prefix1 = 'YYYYMMDD';
      this.isReadonly1 = true;
    } else {
      this.prefix1 = '';
      this.isReadonly1 = false;
    }
  }

  onType2Change() {
    if (Number(this.typeSelected2) === 3) {
      this.prefix2 = 'YYYYMMDD';
      this.isReadonly2 = true;
    } else {
      this.prefix2 = '';
      this.isReadonly2 = false;
    }
  }

  onType3Change() {
    if (Number(this.typeSelected3) === 3) {
      this.prefix3 = 'YYYYMMDD';
      this.isReadonly3 = true;
    } else {
      this.prefix3 = '';
      this.isReadonly3 = false;
    }
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }
}
